import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
import { SKIP_AUTH } from '@app/constants/constant';

function isLoginRequest(url: string, body: unknown): boolean {
  return (
    url === environment.graphqlURI &&
    typeof body === 'object' &&
    body !== null &&
    'query' in body &&
    typeof (body as { query: unknown }).query === 'string' &&
    (body as { query: string }).query.includes('loginWithEmail')
  );
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const skipAuth = req.context.get(SKIP_AUTH);
  if (skipAuth) {
    return next(req);
  }

  const authService = inject(AuthService);
  if (isLoginRequest(req.url, req.body)) {
    return next(req);
  }

  const token = authService.getToken();

  if (!token) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
